import * as HTTP from "./base";

let endpoint = "company-payments";

const getAll = async (queryString = "") => {
  return await HTTP.get(`${endpoint}${queryString}`);
};

const post = async (data) => {
  return await HTTP.post(endpoint, data);
};

const getById = async (id) => {
  return await HTTP.get(`${endpoint}/${id}`);
};

const update = async (id, data) => {
  return await HTTP.put(`${endpoint}/${id}`, data);
};

const destroy = async (id) => {
  return await HTTP.destroy(`${endpoint}/${id}`);
};
const getAllDiscount = async (data) => {
  return await HTTP.post(`${endpoint}/get-discount`, data);
};

export { getAll, post, getById, update, destroy, getAllDiscount };
